module.exports = __webpack_public_path__ + "img/259e8c0.jpg";